import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import theme from '../../styled/theme';
import Check from './Check';
import { ingredientExtraPrices } from '../../../util/ingredientExtras';

const Wrapper = styled.div`
  background: ${props => (props.background ? `url('${process.env.PUBLIC_URL}/img/${props.background}.png')` : 'none')};
  background-size: cover;
  border-radius: 24px;
  border-bottom: ${props => (props.selected ? `6px solid ${theme.colors.grayDark}` : '0')};
  box-sizing: border-box;
  box-shadow: ${props => (props.selected ? '0 0 8px rgba(0, 0, 0, 0.5)' : 'none')};
  color: white;
  display: flex;
  align-items: center;
  font-family: 'Oneer';
  font-size: ${({ category }) => (category === 'proteins' || category === 'complements' ? '3.25rem' : '2.9rem')};
  line-height: 2.5rem;
  position: relative;
  margin-bottom: 0.75rem;
  height: ${props => (props.height ? props.height : '100px')};

  label {
    cursor: pointer;
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 1rem;
    width: 100%;
  }

  input {
    display: none;
  }
`;

const ExtraBadge = styled.div`
  position: absolute;
  left: 0.55rem;
  right: 0.55rem;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.65);
  color: #d0d0d0;
  border-radius: 12px;
  padding: 0.45rem 0.8rem;
  font-size: 1.15rem;
  font-weight: 800;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 0.4px;
  line-height: 1;
  text-align: center;
`;

const DoubleTapHint = styled.div`
  position: absolute;
  left: 0.5rem;
  top: 0.35rem;
  background: rgba(120, 120, 120, 0.5);
  color: #fff;
  border-radius: 12px;
  padding: 0.35rem 0.65rem;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.4px;
  font-family: Arial, Helvetica, sans-serif;
  text-align: left !important;
`;

class Ingredient extends Component {
  state = {
    selected: false,
  };

  getDisplayName = display => ({ __html: display });

  handleClick = () => {
    this.setState({
      selected: !this.state.selected,
    });
    return true;
  };

  render() {
    const { data, image, id, background, height, addIngredient, selectedData } = this.props;
    const imageUrl = image && `${process.env.PUBLIC_URL}/img/${image}.png`;
    const isSelected = selectedData[data.category].map(value => value.key).includes(id);
    const extraPrice = ingredientExtraPrices[data.key];
    const isExtraIngredient = !!extraPrice;
    const isIngredientExtraActive =
      isExtraIngredient && isSelected && !!selectedData.ingredientExtras?.[data.key];
    const showExtraHint = isExtraIngredient && !isIngredientExtraActive;
    const extraHintText = isSelected ? 'Otro click agrega topping' : 'Extra Topping disponible';

    return (
      <Wrapper background={background} selected={isSelected} height={height} category={data.category}>
        <Fragment>
          <label htmlFor={id}>
            <span dangerouslySetInnerHTML={this.getDisplayName(data.display || data.title)} />
            <div>
              {image && (
                <img src={imageUrl} width="auto" height={data.category === 'sauces' ? '100' : '75'} alt={data.title} />
              )}
            </div>
            <input
              id={id}
              name={id}
              type="checkbox"
              onChange={() => this.handleClick() && addIngredient(data.category, data)}
            />
            {isSelected && <Check height="50" />}
            {showExtraHint && <DoubleTapHint>{extraHintText}</DoubleTapHint>}
            {isIngredientExtraActive && <ExtraBadge>{`Topping +RD$${extraPrice}`}</ExtraBadge>}
          </label>
        </Fragment>
      </Wrapper>
    );
  }
}

Ingredient.propTypes = {
  title: PropTypes.string,
  display: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  background: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  category: PropTypes.string,
  height: PropTypes.string,
  addIngredient: PropTypes.func,
};

export default Ingredient;
